import React, { useState, useEffect } from "react";
import { Button, InputAdornment, Typography } from "@mui/material";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Lock, ShowPass, HidePass } from "../../assets/images/icons";
import { getText } from '../../libs/utils';
import REST from '../../libs/API';

const ChangePass = ({ setActiveForm, setOpenDialog, resetToken }) => {
  const [token] = useState(resetToken);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ password: "", passwordRepeat: "" });
  const [showPasswords, setShowPasswords] = useState({ password: "password", passwordRepeat: "password" });

  useEffect(() => {
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      if (value !== formData.password) {
        return false;
      }
      return true;
    }, []);
  }, [formData.password]);

  useEffect(() => {
    return () => {
      ValidatorForm.removeValidationRule('isPasswordMatch');
      setActiveForm('Auth');
    };
  }, [])

  const handlerSubmit = () => {
    setLoading(true);
    REST.setNewPassword(token, formData.password).then(data => {
      if (!data.success) {
        window.showMessage(data.data[0].message);
        setOpenDialog(false);
      } else {
        window.showMessage(getText('accChangePassSuccess'));
        setOpenDialog(false);
      }
      setLoading(false);
    });
  }

  return (
    <ValidatorForm
      onSubmit={handlerSubmit}
      instantValidate={false}
    >
      <Typography variant="caption" align="center" style={{ maxWidth: 290, margin: "0 auto 7px", display: "inline-block" }}>
        {getText('getPass')}
      </Typography>

      <TextValidator
        fullWidth
        placeholder={getText('loginFormPassLabel')}
        variant="standard"
        name="password"
        type={showPasswords.password}
        onChange={(event) =>
          setFormData({
            ...formData,
            [event.target.name]: event.target.value,
          })
        }
        validators={["required"]}
        errorMessages={[getText('reqiuredField')]}
        value={formData.password}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="start"
              style={{ cursor: "pointer" }}
              onClick={() =>
                showPasswords.password === "password"
                  ? setShowPasswords({ ...showPasswords, password: "text" })
                  : setShowPasswords({ ...showPasswords, password: "password" })
              }
            >
              {showPasswords.password === "password" ? <ShowPass /> : <HidePass />}
            </InputAdornment>
          ),
        }}
      />

      <TextValidator
        fullWidth
        placeholder={getText('loginFormPassRepeat')}
        variant="standard"
        name="passwordRepeat"
        type={showPasswords.passwordRepeat}
        onChange={(event) =>
          setFormData({
            ...formData,
            [event.target.name]: event.target.value,
          })
        }
        validators={['isPasswordMatch', 'required']}
        errorMessages={[getText('repeatPassCorrect'), getText('reqiuredField')]}
        value={formData.passwordRepeat}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="start"
              style={{ cursor: "pointer" }}
              onClick={() =>
                showPasswords.passwordRepeat === "password"
                  ? setShowPasswords({ ...showPasswords, passwordRepeat: "text" })
                  : setShowPasswords({ ...showPasswords, passwordRepeat: "password" })
              }
            >
              {showPasswords.passwordRepeat === "password" ? <ShowPass /> : <HidePass />}
            </InputAdornment>
          ),
        }}
      />

      <Button 
        variant="contained" 
        fullWidth 
        size="large" 
        type="submit"
        disabled={loading}
      >
        {getText('stNetPass')}
      </Button>

    </ValidatorForm>
  );
};

export default ChangePass;
